import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const AboutContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #F5F5DC 0%, #E8D5B7 100%);
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(139, 69, 19, 0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
    opacity: 0.3;
    z-index: 0;
  }
`;

const AboutContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  position: relative;
  z-index: 1;
`;

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  color: #8B4513;
  text-decoration: none;
  margin-bottom: 2rem;
  font-weight: 500;
  transition: color 0.3s ease;

  &:hover {
    color: #A0522D;
  }
`;

const AboutCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 3rem;
  border: 1px solid rgba(139, 69, 19, 0.1);
  box-shadow: 0 8px 32px rgba(139, 69, 19, 0.15);
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: #2C3E50;
  text-align: center;
  font-weight: 800;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Section = styled.section`
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #2C3E50;
  font-weight: 700;
`;

const Text = styled.p`
  color: #5D6D7E;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-size: 1.05rem;
`;

const FeatureList = styled.ul`
  list-style: none;
  color: #5D6D7E;
  line-height: 1.6;
`;

const FeatureItem = styled.li`
  margin-bottom: 0.75rem;
  padding-left: 1.5rem;
  position: relative;
  font-size: 1.05rem;

  &:before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #8B4513;
    font-weight: bold;
  }
`;

// FAQ Styles
const FAQSection = styled.section`
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  padding: 2rem;
  border: 1px solid rgba(139, 69, 19, 0.1);
  box-shadow: 0 8px 32px rgba(139, 69, 19, 0.15);
  margin-bottom: 2rem;
`;

const FAQTitle = styled.h2`
  font-size: 1.8rem;
  color: #2C3E50;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 700;
`;

const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FAQItem = styled.div`
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(139, 69, 19, 0.1);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(139, 69, 19, 0.1);
    transform: translateY(-2px);
  }
`;

const FAQQuestion = styled.div`
  padding: 1.25rem;
  font-weight: 600;
  color: #2C3E50;
  font-size: 1.05rem;
  background: rgba(245, 245, 220, 0.5);
  border-bottom: 1px solid rgba(139, 69, 19, 0.1);
`;

const FAQAnswer = styled.div`
  padding: 1.25rem;
  color: #5D6D7E;
  line-height: 1.6;
  font-size: 1rem;
`;

// Contact Styles
const ContactSection = styled.section`
  background: linear-gradient(135deg, #2C3E50 0%, #34495E 100%);
  border-radius: 20px;
  padding: 2.5rem;
  color: white;
  text-align: center;
  box-shadow: 0 8px 32px rgba(139, 69, 19, 0.2);
`;

const ContactTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  font-weight: 700;
`;

const ContactDescription = styled.p`
  font-size: 1.1rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.6;
`;

const ContactEmail = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  color: white;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }
`;

const faqData = [
  {
    question: "What is Monument Valley 3?",
    answer: "Monument Valley 3 is a puzzle game where you manipulate impossible architecture and optical illusions to guide the silent princess Ida through beautiful monuments. It's the third installment in the acclaimed Monument Valley series."
  },
  {
    question: "How many chapters are in Monument Valley 3?",
    answer: "Monument Valley 3 features 9 main chapters: The Dream, Illusory Forest, Crystal Caverns, Sky Temple, Ocean Dreams, The Artist, Time Maze, Final Journey, and Beyond Dreams."
  },
  {
    question: "Is this guide free to use?",
    answer: "Yes, this Monument Valley 3 walkthrough guide is completely free. We provide video solutions and step-by-step instructions for all levels at no cost."
  },
  {
    question: "What platforms is Monument Valley 3 available on?",
    answer: "Monument Valley 3 is available on iOS (iPhone and iPad) and Android devices. You can download it from the App Store or Google Play Store."
  },
  {
    question: "How do I contact the guide creators?",
    answer: "You can contact us via email at emailpkh3693@gmail.com for any questions, feedback, or suggestions about this Monument Valley 3 guide."
  }
];

const About: React.FC = () => {
  return (
    <AboutContainer>
      <AboutContent>
        <BackLink to="/">← Back to Home</BackLink>

        <AboutCard>
          <Title>About Monument Valley 3 Guide</Title>

          <Section>
            <SectionTitle>Project Overview</SectionTitle>
            <Text>
              This is a comprehensive walkthrough guide website designed specifically for Monument Valley 3 players.
              Our mission is to help players better understand and complete every level in the game with detailed
              video demonstrations and puzzle-solving techniques.
            </Text>
            <Text>
              Whether you're stuck on a challenging puzzle or simply want to explore optimal solutions,
              our guide provides step-by-step video walkthroughs for all chapters and levels.
            </Text>
          </Section>

          <Section>
            <SectionTitle>Key Features</SectionTitle>
            <FeatureList>
              <FeatureItem>Complete video walkthroughs for all chapters and levels</FeatureItem>
              <FeatureItem>Clear chapter-by-chapter organization structure</FeatureItem>
              <FeatureItem>Difficulty indicators and level classifications</FeatureItem>
              <FeatureItem>Responsive design supporting all device types</FeatureItem>
              <FeatureItem>Clean, beautiful, and intuitive user interface</FeatureItem>
              <FeatureItem>Step-by-step instructions for complex puzzles</FeatureItem>
              <FeatureItem>Mobile-friendly layout for on-the-go gaming</FeatureItem>
            </FeatureList>
          </Section>

          <Section>
            <SectionTitle>How to Use</SectionTitle>
            <Text>
              <strong>Step 1:</strong> Click "Explore Chapters" on the homepage to access the level selection page<br/>
              <strong>Step 2:</strong> Select your desired chapter and level from the navigation menu<br/>
              <strong>Step 3:</strong> Click on a level card to view detailed video walkthrough<br/>
              <strong>Step 4:</strong> Follow the step-by-step instructions shown in the video to complete the level
            </Text>
          </Section>

          <Section>
            <SectionTitle>Technical Implementation</SectionTitle>
            <Text>
              This website is built with modern web technologies including React and TypeScript, ensuring
              a fast, reliable, and secure user experience. We use Cloudflare Pages for static hosting,
              providing global CDN coverage for optimal performance worldwide.
            </Text>
          </Section>
        </AboutCard>

        <FAQSection>
          <FAQTitle>Frequently Asked Questions</FAQTitle>
          <FAQList>
            {faqData.map((faq, index) => (
              <FAQItem key={index}>
                <FAQQuestion>{faq.question}</FAQQuestion>
                <FAQAnswer>{faq.answer}</FAQAnswer>
              </FAQItem>
            ))}
          </FAQList>
        </FAQSection>

        <ContactSection>
          <ContactTitle>Get in Touch</ContactTitle>
          <ContactDescription>
            Have questions, feedback, or suggestions about our Monument Valley 3 guide?
            We'd love to hear from you! Reach out to us for any inquiries or collaboration opportunities.
          </ContactDescription>
          <ContactEmail href="mailto:emailpkh3693@gmail.com">
            ✉️ emailpkh3693@gmail.com
          </ContactEmail>
        </ContactSection>
      </AboutContent>
    </AboutContainer>
  );
};

export default About;